import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material"
import { AccordionSeeker } from "@ui-seeker/core"

import SkuDuplicatesMarketFilter from "./MarketFilter"
import SkuDuplicatesSitesFilter from "./SitesFilter"
import SkuDuplicatesBrandsFilter from "./BrandsFilter"
import SkuDuplicatesFiltersFooter from "./Footer"
import { includeInactive } from "../@signals"


export default function SkuDuplicatesFilters() {
    const isOpen = useSignal(true)

    return <AccordionSeeker
        title="Filters"
        TransitionProps={{ unmountOnExit: false }}
        expanded={isOpen.value}
        onChange={() => isOpen.value = !isOpen.value}
        footerActions={<SkuDuplicatesFiltersFooter />}
    >
        <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
                <SkuDuplicatesMarketFilter />
            </Grid>
            <Grid item xs={12} md={4}>
                <SkuDuplicatesSitesFilter />
            </Grid>
            <Grid item xs={12} md={4}>
                <SkuDuplicatesBrandsFilter />
            </Grid>
            <Grid item xs={12}>
                <FormControlLabel
                    control={<Checkbox
                        size="small"
                        checked={includeInactive.value}
                        onChange={e => includeInactive.value = e.target.checked}
                    />}
                    label={<Typography variant="body2">
                        Include inactive products
                        <Typography component="span" variant="caption" color="text.secondary" sx={{ ml: 1 }}>
                            (by default only products seen in the last 30 days count)
                        </Typography>
                    </Typography>}
                />
            </Grid>
        </Grid>
    </AccordionSeeker>
}
